import React from 'react';
import { Link } from 'react-router-dom';

const NotificationButton = () => {
  return (
    <div className="position-relative">
      <Link className="nav-link" to="#">
        <i className="fas fa-bell fs-4"></i>
        <span className="badge bg-danger rounded-pill position-absolute top-0 start-100 translate-middle">3</span>
      </Link>
    </div>
  );
};

export default NotificationButton;
